export type SourceCitation = {
  label: string;
  href: string;
};

// The assistant is instructed to cite what it used, one per line, at the end of
// its reply:
//
//   From: [Home Office Policy](/people/documents?document=a0X…)   ← company doc
//   Source: [How to request leave](https://help.flair.hr/…)       ← knowledge base
//
// Rendered as markdown those become plain blue hyperlinks buried in a wall of
// text. They are the most clickable thing in the answer and looked the least
// clickable. We lift them out of the prose and render them as chips instead.
//
// Leading list markers are tolerated because the model sometimes bullets them.
const CITATION_LINE =
  /^\s*(?:[-*]\s*)?(?:from|source):\s*\[([^\]]+)\]\(([^)\s]+)\)\s*$/i;

export function extractSourceCitations(markdown: string): {
  body: string;
  sources: SourceCitation[];
} {
  const sources: SourceCitation[] = [];
  const seen = new Set<string>();
  const kept: string[] = [];

  for (const line of markdown.split('\n')) {
    const match = CITATION_LINE.exec(line);
    if (!match) {
      kept.push(line);
      continue;
    }
    const [, label, href] = match;
    if (seen.has(href)) continue;
    seen.add(href);
    sources.push({ label: label.trim(), href });
  }

  // A reply that is *only* citations would otherwise render as an empty bubble.
  // Trailing blank lines are left by the removed citation lines.
  const body = kept.join('\n').replace(/\s+$/, '');

  return { body, sources };
}

// Hub routes are relative; knowledge-base articles are absolute. The first must
// navigate inside the app (a full page load would drop the chat), the second
// opens in a new tab.
export function isInternalHref(href: string): boolean {
  return href.startsWith('/');
}
